module.exports = __webpack_public_path__ + "images/white_logo.png";